/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";

export const SenderEmailColumnFormatter = (cellContent, row, rowIndex) => {
  const { senderEmail } = row;

  return (
    <>
      <div className="d-flex align-items-center">
        {senderEmail ? senderEmail : `-`}
      </div>
      <> </>
    </>
  );
};
